<template>
  <div class="container">
        <baidu-map @ready="mapHandle" style="width:100%;height:600px" >
            <bm-navigation anchor="BMAP_ANCHOR_TOP_RIGHT"></bm-navigation>
            <bm-map-type :map-types="['BMAP_NORMAL_MAP', 'BMAP_HYBRID_MAP']" anchor="BMAP_ANCHOR_TOP_LEFT"></bm-map-type>
        </baidu-map>
  </div>
</template>
<script>
export default {
    props: {
        storagePositionArr: {
            type: Array,
            default() {
                return '';
            }
        }
    },
    methods: {
        // BMap百度对象，map是地图对象
        mapHandle({ BMap, map }) {
            map.enableScrollWheelZoom(true);
            const pointArr = [];
            this.storagePositionArr.map(ele => {
                const point = new BMap.Point(ele.lng, ele.lat);
                const marker = new BMap.Marker(point);
                const lable = new BMap.Label(ele.whName, { position: point, offset: new BMap.Size(-5, 2) });
                lable.setStyle({
                    color: 'red',
                    fontSize: '12px',
                    border: '0',
                    backgroundColor: 'none'
                });
                map.addOverlay(marker);
                map.addOverlay(lable);
                pointArr.push(point);
            });
            // 展示所有标记点
            map.setViewport(pointArr);
        }
    }
};
</script>